<template>
  <div>
    <JobListCmp />
  </div>
</template>

<script>
import JobListCmp from '@/components/JobList.vue'

export default {
  name: 'JobList',
  components: {
      JobListCmp
  }
}
</script>

<style>
.sr-only{display:none !important}
/*
.jobvite-joblist-container .table-wrap {
  text-align: center;
  display: inline-block;
  background-color: #fff;
  color: #000;
  width: 100%;
}

.jobvite-joblist-container table {
  border: 1px solid #ccc;
  width: 100%;
  margin:0;
  padding:0;
  border-collapse: collapse;
  border-spacing: 0;
}

.jobvite-joblist-container table tr {
  border: 1px solid #ddd !important;
  padding: 5px;
}

.jobvite-joblist-container table th, .jobvite-joblist-container table td {
  padding: 10px;
  border: none !important;
}

.jobvite-joblist-container table th {
  color: #fff;
  background-color: #444;
  text-transform: uppercase;
  font-size: 14px !important;
  letter-spacing: 1px;
}

.jobvite-joblist-container table td {
  font-size: 14px !important;
}

.jobvite-joblist-container table td a {
  color: black;
  font-weight: bold;
}

.jobvite-joblist-container .table-search {
  margin-top: 5px;
  width: 100%;
  max-width: 200px;
  height: 20px !important;
  padding-left: 15px;
  box-sizing: border-box;
}

.jobvite-joblist-container .pagination-link {
  display: inline-block;
  font-size: 14px !important;
  padding: 5px 15px;
  margin: 3px;
  border: 1px solid #444;
  color: white;
  background: #444;
  text-decoration: none;
  cursor: pointer;
  transition: all .2s;
}

.jobvite-joblist-container .pagination-link.active {
  transform: scale(1.2);
  cursor: default;
}

.jobvite-joblist-container .pagination-link:not(.active):hover {
  background: #555;
}

.jobvite-joblist-container .jobvite-pagination {
  padding: 20px;
}

@media screen and (min-width: 720px) {
  .jobvite-joblist-container table td:first-child {
    text-align: left;
  }
}

@media screen and (max-width: 720px) {
  .jobvite-joblist-container table {
    border: 0;
  }
  .jobvite-joblist-container table thead {
    display: none;
  }
  .jobvite-joblist-container table tr {
    margin-bottom: 10px;
    display: block;
    border-bottom: 2px solid #ddd;
  }
  .jobvite-joblist-container table td {
    display: block;
    text-align: right;
    font-size: 13px !important;
    border-bottom: 1px dotted #ccc;
    border-right: 1px solid transparent;
  }
  .jobvite-joblist-container table td:last-child {
    border-bottom: 0;
  }
  .jobvite-joblist-container table td:before {
    content: attr(data-label);
    float: left;
    text-transform: uppercase;
    font-weight: bold;
  }
}*/
</style>
